// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FinanceView_container__ahD-I {
  width: 85%;
  padding: 30px;
  margin-left: auto;
  text-align: left;
}

.FinanceView_add__F8\\+Ga {
  position: absolute;
  top: 4.7rem;
  right: 2rem;
  background: rgba(29, 135, 82, 1);
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  font-size: 25px;
}

.FinanceView_financeContainer__ns5PM {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.FinanceView_timeFilter__KD0vY {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.FinanceView_timeBtn__I3oue {
  padding: 6px 12px;
  border: 1px solid #ccc;
  background: #f9f9f9;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.FinanceView_timeBtn__I3oue:hover {
  color: white;
  background:  rgba(24, 115, 70, 0.541);
}

.FinanceView_activeTimeBtn__vndm7 {
  background:  rgba(24, 115, 70, 1);
  color: #fff;
  border-color:  rgba(24, 115, 70, 1);
}

.FinanceView_tableWrapper__aOyih {
  overflow-x: auto;
  margin-bottom: 30px;
}

.FinanceView_table__XqJuq {
  width: 100%;
  border-collapse: collapse;
}

.FinanceView_table__XqJuq th,
.FinanceView_table__XqJuq td {
  padding: 10px;
  border-bottom: 1px solid #eee;
  text-align: left;
}

.FinanceView_balance__60aFN {
  font-weight: bold;
}

.FinanceView_actionsCell__qUcWU {
  display: flex;
  gap: 5px;
  justify-content: center;
}

.FinanceView_editBtn__5u65C,
.FinanceView_deleteBtn__yTHfV {
  border: none;
  background: none;
  cursor: pointer;
  padding: 4px;
  transition: all 0.2s;
}

.FinanceView_editBtn__5u65C:hover {
  color:  rgba(24, 115, 70, 1);
}

.FinanceView_deleteBtn__yTHfV:hover {
  color: red;
}

.FinanceView_chartWrapper__eDyET {
  width: 100%;
  margin-top: 20px;
}


.FinanceView_actionsCell__qUcWU {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.FinanceView_editBtn__5u65C,
.FinanceView_deleteBtn__yTHfV {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  transition: 0.2s;
}

.FinanceView_editBtn__5u65C:hover {
  color: rgba(24, 115, 70, 1);
}

.FinanceView_deleteBtn__yTHfV:hover {
  color: #e63946;
}

.FinanceView_title__4Wz0y {
  font-size: 22px;
  font-weight: bold;
  color: #1f2937; /* темно-серый */
  margin-bottom: 20px;
}

.FinanceView_tabs__kMx5b {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.FinanceView_chartWrapper__eDyET {
  margin-top: 20px;
  padding: 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}


.FinanceView_tab__-Ozlj {
  padding: 10px 20px;
  border-radius: 8px;
  background: #f3f4f6; /* светло-серый */
  color: #374151; /* серый текст */
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.FinanceView_tab__-Ozlj:hover {
  background: #e5e7eb;
}

.FinanceView_activeTab__iBqnF {
    background: rgba(24, 115, 70, 1);
    color: white;
    box-shadow: 0 4px 12px rgba(152, 247, 74, 0.3);
}

.FinanceView_card__xX6bo {
  background: #fff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.FinanceView_loading__cUzBj,
.FinanceView_empty__PhNNV {
  color: #6b7280;
  font-size: 14px;
  text-align: center;
  padding: 20px;
}

.FinanceView_table__XqJuq {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.FinanceView_table__XqJuq thead {
  background: #f9fafb;
  color: #6b7280;
  text-transform: uppercase;
  font-size: 12px;
}

.FinanceView_table__XqJuq th,
.FinanceView_table__XqJuq td {
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  text-align: left;
}

.FinanceView_table__XqJuq tr:hover {
  background: #f3f4f6;
}

.FinanceView_balance__60aFN {
  font-weight: 600;
  color: #059669; /* зеленый */
}

.FinanceView_depositBtn__9cn82 {
  color: #22c55e;
}

.FinanceView_withdrawBtn__s6i0P {
  color: #ef4444;
}

.FinanceView_depositBtn__9cn82,
.FinanceView_withdrawBtn__s6i0P,
.FinanceView_editBtn__5u65C,
.FinanceView_deleteBtn__yTHfV {
  background: transparent;
  border: none;
  cursor: pointer;
  margin: 0 4px;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.FinanceView_depositBtn__9cn82:hover,
.FinanceView_withdrawBtn__s6i0P:hover,
.FinanceView_editBtn__5u65C:hover,
.FinanceView_deleteBtn__yTHfV:hover {
  transform: scale(1.1);
  opacity: 0.8;
}


`, "",{"version":3,"sources":["webpack://./src/styles/FinanceView.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc,EAAE,gBAAgB;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB,EAAE,iBAAiB;EACtC,cAAc,EAAE,gBAAgB;EAChC,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,8CAA8C;AAClD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc,EAAE,YAAY;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,oDAAoD;AACtD;;AAEA;;;;EAIE,qBAAqB;EACrB,YAAY;AACd","sourcesContent":[".container {\n  width: 85%;\n  padding: 30px;\n  margin-left: auto;\n  text-align: left;\n}\n\n.add {\n  position: absolute;\n  top: 4.7rem;\n  right: 2rem;\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  padding: 5px 20px;\n  border-radius: 5px;\n  font-size: 25px;\n}\n\n.financeContainer {\n  padding: 20px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n}\n\n.timeFilter {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.timeBtn {\n  padding: 6px 12px;\n  border: 1px solid #ccc;\n  background: #f9f9f9;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.timeBtn:hover {\n  color: white;\n  background:  rgba(24, 115, 70, 0.541);\n}\n\n.activeTimeBtn {\n  background:  rgba(24, 115, 70, 1);\n  color: #fff;\n  border-color:  rgba(24, 115, 70, 1);\n}\n\n.tableWrapper {\n  overflow-x: auto;\n  margin-bottom: 30px;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table th,\n.table td {\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n  text-align: left;\n}\n\n.balance {\n  font-weight: bold;\n}\n\n.actionsCell {\n  display: flex;\n  gap: 5px;\n  justify-content: center;\n}\n\n.editBtn,\n.deleteBtn {\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 4px;\n  transition: all 0.2s;\n}\n\n.editBtn:hover {\n  color:  rgba(24, 115, 70, 1);\n}\n\n.deleteBtn:hover {\n  color: red;\n}\n\n.chartWrapper {\n  width: 100%;\n  margin-top: 20px;\n}\n\n\n.actionsCell {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n}\n\n.editBtn,\n.deleteBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  transition: 0.2s;\n}\n\n.editBtn:hover {\n  color: rgba(24, 115, 70, 1);\n}\n\n.deleteBtn:hover {\n  color: #e63946;\n}\n\n.title {\n  font-size: 22px;\n  font-weight: bold;\n  color: #1f2937; /* темно-серый */\n  margin-bottom: 20px;\n}\n\n.tabs {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.chartWrapper {\n  margin-top: 20px;\n  padding: 16px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.1);\n}\n\n\n.tab {\n  padding: 10px 20px;\n  border-radius: 8px;\n  background: #f3f4f6; /* светло-серый */\n  color: #374151; /* серый текст */\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.tab:hover {\n  background: #e5e7eb;\n}\n\n.activeTab {\n    background: rgba(24, 115, 70, 1);\n    color: white;\n    box-shadow: 0 4px 12px rgba(152, 247, 74, 0.3);\n}\n\n.card {\n  background: #fff;\n  border-radius: 16px;\n  padding: 16px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.loading,\n.empty {\n  color: #6b7280;\n  font-size: 14px;\n  text-align: center;\n  padding: 20px;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.table thead {\n  background: #f9fafb;\n  color: #6b7280;\n  text-transform: uppercase;\n  font-size: 12px;\n}\n\n.table th,\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e5e7eb;\n  text-align: left;\n}\n\n.table tr:hover {\n  background: #f3f4f6;\n}\n\n.balance {\n  font-weight: 600;\n  color: #059669; /* зеленый */\n}\n\n.depositBtn {\n  color: #22c55e;\n}\n\n.withdrawBtn {\n  color: #ef4444;\n}\n\n.depositBtn,\n.withdrawBtn,\n.editBtn,\n.deleteBtn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  margin: 0 4px;\n  transition: transform 0.15s ease, opacity 0.15s ease;\n}\n\n.depositBtn:hover,\n.withdrawBtn:hover,\n.editBtn:hover,\n.deleteBtn:hover {\n  transform: scale(1.1);\n  opacity: 0.8;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FinanceView_container__ahD-I`,
	"add": `FinanceView_add__F8+Ga`,
	"financeContainer": `FinanceView_financeContainer__ns5PM`,
	"timeFilter": `FinanceView_timeFilter__KD0vY`,
	"timeBtn": `FinanceView_timeBtn__I3oue`,
	"activeTimeBtn": `FinanceView_activeTimeBtn__vndm7`,
	"tableWrapper": `FinanceView_tableWrapper__aOyih`,
	"table": `FinanceView_table__XqJuq`,
	"balance": `FinanceView_balance__60aFN`,
	"actionsCell": `FinanceView_actionsCell__qUcWU`,
	"editBtn": `FinanceView_editBtn__5u65C`,
	"deleteBtn": `FinanceView_deleteBtn__yTHfV`,
	"chartWrapper": `FinanceView_chartWrapper__eDyET`,
	"title": `FinanceView_title__4Wz0y`,
	"tabs": `FinanceView_tabs__kMx5b`,
	"tab": `FinanceView_tab__-Ozlj`,
	"activeTab": `FinanceView_activeTab__iBqnF`,
	"card": `FinanceView_card__xX6bo`,
	"loading": `FinanceView_loading__cUzBj`,
	"empty": `FinanceView_empty__PhNNV`,
	"depositBtn": `FinanceView_depositBtn__9cn82`,
	"withdrawBtn": `FinanceView_withdrawBtn__s6i0P`
};
export default ___CSS_LOADER_EXPORT___;
